import "./common/utils/middleware/config.sentry.js"
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './index.css'
import { Provider } from 'react-redux'
import { store } from './common/redux/store/store.js'
import { AuthKeycloak } from '@artprov/design-system'

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('No se encontró el elemento root');
}

ReactDOM.createRoot(rootElement).render(
  <AuthKeycloak
    keycloakConfig={{
      url: import.meta.env.VITE_KEYCLOAK_URL,
      realm: import.meta.env.VITE_KEYCLOAK_REALM,
      clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID,
    }}
    apiConfig={{
      consumidor: "COMPRAS",
      services: [
        {
          name: "compras-back",
          baseURL: import.meta.env.VITE_API_GATEWAY,
        },
      ],
    }}
  >
    <Provider store={store}>
      <App />
    </Provider>
  </AuthKeycloak>
);
